const WEEKDAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
];

const getWeekday = () => WEEKDAYS[new Date().getDay()];

export { WEEKDAYS, getWeekday };
